/**
 * Official brand glyphs for social-share buttons.
 *
 * lucide-react's `X` export is the close-icon (✕), not the X (formerly Twitter)
 * brand mark — using it for a "Share on X" button shows a literal cross, which
 * reads as a "close" or "remove" action. lucide's `LinkedinIcon` is also older
 * stylistically.
 *
 * These two components use the canonical brand SVG paths from each company's
 * brand guidelines. Render at 20×20 (h-5 w-5) to match prior placement.
 *
 * `currentColor` is used for fill so the existing Tailwind hover transitions
 * (`hover:bg-[#0A66C2] hover:text-white`, etc.) keep working unchanged.
 */

import type { SVGProps } from 'react';

export function LinkedInBrandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

export function XBrandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}
